import React from 'react';
import { TextLead, ThemedButton } from '@awarego-ui/components';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import HeaderSection from '../../../../components/header/HeaderSection';

function RecommendationHeader({ listId = 'all', isCustom = false }) {
    const createHeading = () => (
        <TextLead bold>Recommended training plan</TextLead>
    );

    const constructUrl = () => {
        let url = 'create-training';

        if (listId !== 'all') {
            url = `create-training/${listId}`;
        }

        return url;
    };

    return (
        <HeaderSection
            style={{ marginBottom: '32px' }}
            excludeBlock
            heading={createHeading()}
            buttons={
                <ThemedButton
                    mode={isCustom ? 'secondary' : 'primary'}
                    text={
                        isCustom
                            ? 'Create as one training…'
                            : 'Create training…'
                    }
                    as={Link}
                    to={constructUrl()}
                    $noTextTransform
                    $center
                    $noWrap
                    style={{
                        display: 'flex',
                        marginLeft: '-100px',
                        marginTop: '15px',
                    }}
                />
            }
        />
    );
}

export default observer(RecommendationHeader);
